import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const MEMBERSHIP_LEVEL_API_URL = `${API_HOST}/api/membershipLevel`;
const MEMBERSHIP_LEVEL_RULE_API_URL = `${API_HOST}/api/membershipLevel/rule`;
const MEMBERSHIP_LEVEL_TRANSITION_RECORD_API_URL = `${API_HOST}/api/membershipLevel/record/transition`;
const MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORD_API_URL = `${API_HOST}/api/membershipLevel/record/manualAdjustment`;
const MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORD_API_URL = `${API_HOST}/api/membershipLevel/record/nonManualAdjustment`;

function* searchMembershipLevels() {
  yield takeEvery(actions.SEARCH_MEMBERSHIP_LEVELS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MEMBERSHIP_LEVEL_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MEMBERSHIP_LEVELS_ENDED });
    }
  });
}

function* searchMembershipLevelRules() {
  yield takeEvery(actions.SEARCH_MEMBERSHIP_LEVEL_RULES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MEMBERSHIP_LEVEL_RULE_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MEMBERSHIP_LEVEL_RULES_ENDED });
    }
  });
}

function* searchMembershipLevelTransitionRecords() {
  yield takeEvery(actions.SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MEMBERSHIP_LEVEL_TRANSITION_RECORD_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS_ENDED });
    }
  });
}

function* searchMembershipLevelManualAdjustmentRecords() {
  yield takeEvery(actions.SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORD_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS_ENDED });
    }
  });
}

function* searchMembershipLevelNonManualAdjustmentRecords() {
  yield takeEvery(
    actions.SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS,
    function* (action) {
      const { parameters, onSuccess } = action;
      try {
        const res = yield call(
          [axios, 'get'],
          `${MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORD_API_URL}?${parameters.toString()}`,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (error) {
        yield handleError(error);
      } finally {
        yield put({ type: actions.SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS_ENDED });
      }
    },
  );
}

function* getEnabledMembershipLevels() {
  yield takeEvery(actions.GET_ENABLED_MEMBERSHIP_LEVELS, function* () {
    try {
      const parameters = new URLSearchParams({
        enabled: 1,
        page: 1,
        number_per_page: 100,
        sort_by: 'id',
        order: 'asc',
      });
      const res = yield call(
        [axios, 'get'],
        `${MEMBERSHIP_LEVEL_API_URL}?${parameters.toString()}`,
      );
      yield put({
        type: actions.GET_ENABLED_MEMBERSHIP_LEVELS_END,
        levels: res.data.data,
      });
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_ENABLED_MEMBERSHIP_LEVELS_END });
    }
  });
}

function* createMembershipLevel() {
  yield takeEvery(actions.CREATE_MEMBERSHIP_LEVEL, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MEMBERSHIP_LEVEL_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_MEMBERSHIP_LEVEL_ENDED });
    }
  });
}

function* createMembershipLevelRule() {
  yield takeEvery(actions.CREATE_MEMBERSHIP_LEVEL_RULE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MEMBERSHIP_LEVEL_RULE_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_MEMBERSHIP_LEVEL_RULE_ENDED });
    }
  });
}

function* updateMembershipLevel() {
  yield takeEvery(actions.UPDATE_MEMBERSHIP_LEVEL, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MEMBERSHIP_LEVEL_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_MEMBERSHIP_LEVEL_ENDED });
    }
  });
}

function* updateMembershipLevelRule() {
  yield takeEvery(actions.UPDATE_MEMBERSHIP_LEVEL_RULE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MEMBERSHIP_LEVEL_RULE_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_MEMBERSHIP_LEVEL_RULE_ENDED });
    }
  });
}

function* deleteMembershipLevels() {
  yield takeEvery(actions.DELETE_MEMBERSHIP_LEVELS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], MEMBERSHIP_LEVEL_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_MEMBERSHIP_LEVELS_ENDED });
    }
  });
}

function* deleteMembershipLevelRules() {
  yield takeEvery(actions.DELETE_MEMBERSHIP_LEVEL_RULES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], MEMBERSHIP_LEVEL_RULE_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_MEMBERSHIP_LEVEL_RULES_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchMembershipLevels),
    fork(searchMembershipLevelRules),
    fork(searchMembershipLevelTransitionRecords),
    fork(searchMembershipLevelManualAdjustmentRecords),
    fork(searchMembershipLevelNonManualAdjustmentRecords),
    fork(createMembershipLevel),
    fork(createMembershipLevelRule),
    fork(updateMembershipLevel),
    fork(updateMembershipLevelRule),
    fork(getEnabledMembershipLevels),
    fork(deleteMembershipLevels),
    fork(deleteMembershipLevelRules),
  ]);
}
